module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-arrange-365ddf38c691b94c9514751e398df40f.png";